<script setup lang="ts">
withDefaults(
  defineProps<{
    disabled?: boolean
    loading?: boolean
    size?: 'sm' | 'xs'
    type?: 'button' | 'submit' | 'reset'
    variant?: 'outlined' | 'text'
    loadingPosition?: 'left' | 'center'
  }>(),
  {
    loadingPosition: 'left',
  },
)

defineOptions({ name: 'UiButton' })
</script>

<template>
  <button
    class="font-display btn focus:ring-secondary-300 relative flex outline-none focus:ring-2"
    :class="{
      'pointer-events-none': loading,
      'btn-filled': !variant,
      'btn-outlined': variant === 'outlined',
      'btn-text': variant === 'text',
      'text-sm': size === 'sm',
      'text-xs': size === 'xs',
    }"
    :disabled="disabled"
    :type="type || 'button'"
  >
    <div
      :class="{
        'ml-6': loading && loadingPosition === 'left',
        'opacity-40': loading,
      }"
    >
      <slot />
    </div>

    <div
      v-if="loading"
      :class="[
        'absolute z-10 flex items-center',
        loadingPosition === 'left'
          ? 'left-2'
          : 'inset-0 h-full flex-1 -translate-x-1 transform justify-center',
      ]"
    >
      <div class="i-ph-circle-notch-bold h-4 w-4 animate-spin" />
    </div>
  </button>
</template>
